import type { ReactNode } from 'react';
import { DirectionProvider } from '@radix-ui/react-direction';
import { useLocaleDirection } from './useLocaleDirection';

/**
 * Radix reads direction from this context, NOT from the inherited <html dir>. Without it
 * useDirection() falls back to a hardcoded 'ltr' and every primitive stamps dir="ltr" onto
 * its own DOM node — an LTR island that overrides the page. Must wrap the whole tree.
 */
export const RadixDirectionProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <DirectionProvider dir={useLocaleDirection()}>{children}</DirectionProvider>
);
